import Auth from '../api/auth';
import { getEmbeddedAccessToken } from './embeddedAuth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  const embeddedAccessToken = getEmbeddedAccessToken();
  // Add Auth Headers to requests if logged in
  if (embeddedAccessToken) {
    Object.assign(wootApi.defaults.headers.common, {
      api_access_token: embeddedAccessToken,
    });
  } else if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
